import axios from 'axios'
import { getCookie } from 'libs/utils'

const TIMEOUT = '请求超时'

// 设置 7 秒超时
const timeout = reject =>
  setTimeout(() => reject(TIMEOUT), 10e3)

export default {
  // 查询当前用户的消息
  getMessageList ({
    id,
    contextType,
    currPage = 1,
    pageSize = 10
  }) {
    const url = '/dashboard/message/get-message'
    return new Promise((resolve, reject) => {
      axios.post(url, {
        id,
        contextType,
        currPage: currPage-1,
        pageSize
      }).then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 当前消息标记已读
  markMessage ({
    ids
  }) {
    const url = '/dashboard/message/read'
    return new Promise((resolve, reject) => {
      axios.post(url, {
        ids,
      }).then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 全部消息标记已读
  markAllMessage () {
    const url = `/dashboard/message/mark-all`
    return new Promise((resolve, reject) => {
      axios.get(url).then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 删除当前消息（无论是否已读）
  deleteMessage ({
    ids,
    sender = 'dashboard',
    receiver = getCookie('account_id')
  }) {
    const url = '/dashboard/message/delete'
    return new Promise((resolve, reject) => {
      axios.post(url, {
        ids
      }).then(resp => resolve(resp.data))
      timeout(reject)
    })
  },
  // 获取未读消息数量
  unreadCount ({
    sender = 'dashboard',
    receiver = getCookie('account_id')
  }) {
    const url = `/dashboard/message/count?sender=${sender}&receiver=${receiver}`
    return new Promise((resolve, reject) => {
      axios.get(url).then(resp => resolve(resp.data))
      timeout(reject)
    })
  }
}


// WEBPACK FOOTER //
// ./app/api/message.js